export default __webpack_public_path__ + "static/media/1911.ba694d2f.png";